var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning"}},[_vm._v("\n                Errore di caricamento :(\n        ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }